import { render, staticRenderFns } from "./SubsdiaryLedger.vue?vue&type=template&id=19b41c4d"
import script from "./SubsdiaryLedger.vue?vue&type=script&lang=js"
export * from "./SubsdiaryLedger.vue?vue&type=script&lang=js"
import style0 from "./SubsdiaryLedger.vue?vue&type=style&index=0&id=19b41c4d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports